



































import Vue from 'vue';
import tableComponent from '@/components/TheTable.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { requestUploadLegalFile } from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;

@Component({
  name: 'LegalPage',
  components: {
    SidebarRight,
    tableComponent,
    titlePageComponent,
    PulseLoader
  }
})
export default class LegalPage extends Base {
  btnText = 'Upload document';
  legalDocumentTable = {
    titleText: 'LIST OF LEGAL DOCUMENTS',
    titleBg: 'orange-title',
    sorted: 'id',
    columns: [
      {field: 'id', title: '#'},
      {field: 'title', title: 'TITLE'},
      {field: 'creator', title: 'BY'},
      {field: 'date', title: 'UPLOADED'},
      {field: 'action', title: 'ACTION'}
    ],
    rows: []
  };

  // Computed
  get isUploadDocumentPending() {
    return this.getPendings.legalDocument.new;
  }

  get legalDocumentData() {
    let rows: any[] = [];
    for (let variable in this.getLegalDocuments) {
      let row: any = {};
      let document = this.getLegalDocuments[variable];
      row.id = document.id;
      row.title = document.title;
      row.name = document.name;
      row.fileHash = document.fileHash;
      row.creator = this.getMember(document.address)
        ? this.getMember(document.address).name
        : document.address && !this.getMember(document.address)
          ? 'Agent'
          : '';
      row.date = this.$moment.unix(document.creationTime).format(FORMAT_DATE);
      rows.push(row);
    }
    Vue.set(this.legalDocumentTable, 'rows', rows);
    return this.legalDocumentTable;
  }

  // Methods
  requestUploadFile() {
    this.setSideBarForm(requestUploadLegalFile());
    this.openClose();
  }

  downloadDocument(row) {
    this.ipfs.getFileByXHR(row.fileHash).then(blob => {
      this.downloadFile(blob, row.name);
    });
  }

  downloadFile(blob, fileName): void {
    const a: HTMLAnchorElement = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
};
